/* eslint-disable react/no-unstable-nested-components */
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { MessageDisplay, ImageLoader } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import { ref, orderByChild, query } from 'firebase/database';
import firebase from 'firebase/firebase';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useList } from 'react-firebase-hooks/database';
import { displayHour, displayActionMessage } from 'helpers/utils';
import { Link, useParams } from 'react-router-dom';
import { MESSAGES } from 'constants/routes';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';

const ViewMessage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const isKeyboardOpen = useDetectKeyboardOpen();

  useScrollTop();
  useDocumentTitle(t('titleMessage'));
  const [messages, isLoadingMessages, errorMessages] = useList(
    query(ref(firebase.rdb, `messages/${id}`), orderByChild('timestamp'))
  );
  const [users, isLoadingUsers, errorUsers] = useList(
    ref(firebase.rdb, `chats/${id}/members`)
  );
  const store = useSelector((state) => ({
    user: state.auth
  }));
  const [messageInput, setMessageInput] = useState('');
  const recipientId = useRef();
  const elementRef = useRef();

  useEffect(() => {
    if (isKeyboardOpen) {
      elementRef.current.scrollIntoView();
    }
  }, [isKeyboardOpen]);

  useEffect(() => {
    if (!isLoadingMessages && messages.length !== 0) {
      firebase.setReadMessages(id, store.user.id);
    }
  }, [messages]);

  const onInputChange = (e) => {
    const val = e.target.value.trimStart();
    setMessageInput(val);
  };

  const onClickSend = () => {
    if (messageInput.length > 0) {
      firebase
        .sendMessage(id, recipientId.current.id, {
          sender: store.user.id,
          timestamp: new Date().getTime(),
          text: messageInput
        })
        .then(() => setMessageInput(''))
        .catch(() => displayActionMessage('messagesSendError', 'error'));
    }
  };

  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      onClickSend();
    }
  };

  return (
    <div style={{ margin: 'auto', display: 'block', marginBottom: '-50px' }}>
      {isLoadingMessages && isLoadingUsers && (
        <div className="loader">
          <h4>{t('loadingMessage')}</h4>
          <br />
          <LoadingOutlined style={{ fontSize: '3rem' }} />
        </div>
      )}
      {errorMessages && <MessageDisplay message={errorMessages} />}
      {errorUsers && <MessageDisplay message={errorUsers} />}
      {messages && users && !isLoadingMessages && !isLoadingUsers && (
        <div>
          <Link to={MESSAGES}>
            <div style={{ width: '100%' }}>
              {users.map(
                (user) =>
                  user.key !== store.user.id && (
                    <div
                      key={user.key}
                      ref={recipientId}
                      id={user.key}
                      className="chat-nav"
                    >
                      <ArrowLeftOutlined />
                      &nbsp;
                      <div className="chat-img-wrapper">
                        <ImageLoader
                          alt="Image"
                          className="item-img chat-img"
                          src={user.val().avatar}
                        />
                      </div>
                      <div style={{ marginLeft: '10px' }}>
                        {user.val().name}
                      </div>
                    </div>
                  )
              )}
            </div>
          </Link>
          {messages.length !== 0 && (
            <div>
              <div className="message-content">
                {messages.map((message) => (
                  <div key={message.key}>
                    {store.user.id !== message.val().sender ? (
                      <div className="message-container">
                        <div>{message.val().text}</div>
                        <span>{displayHour(message.val().timestamp)}</span>
                      </div>
                    ) : (
                      <div className="own-message-container">
                        <div>{message.val().text}</div>
                        <span>{displayHour(message.val().timestamp)}</span>
                      </div>
                    )}
                  </div>
                ))}
                <div ref={elementRef} />
              </div>
              <div style={{ display: 'flex', marginTop: '20px' }}>
                <input
                  className="search-input searchbar-input chat-input"
                  onKeyUp={onKeyUp}
                  onChange={onInputChange}
                  placeholder={t('messagesPlaceholder')}
                  type="text"
                  value={messageInput}
                />
                <button
                  className="button button-small"
                  type="button"
                  onClick={onClickSend}
                >
                  <FontAwesomeIcon icon={faPaperPlane} />
                </button>
              </div>
            </div>
          )}
          {messages.length === 0 && <p>{t('messagesEmptyError')}</p>}
        </div>
      )}
    </div>
  );
};

export default ViewMessage;
